/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { IUser } from '../../types/user/IUser';
import { AuthActions, AuthActionTypes } from './types';

export const authSetUser = (user: IUser): AuthActionTypes => ({
  type: AuthActions.AUTH_SET_USER,
  payload: { user },
});

export const authorizeUserByToken = (token: string, expires: Date): AuthActionTypes => ({
  type: AuthActions.AUTHORIZE_USER_BY_TOKEN_WATCHER,
  payload: { token, expires },
});

export const authRefreshUser = (): AuthActionTypes => ({
  type: AuthActions.AUTH_REFRESH_USER_WATCHER,
});

export const authRefreshUserActions = {
  start: (): AuthActionTypes => ({ type: AuthActions.AUTH_REFRESH_START }),
  completed: (): AuthActionTypes => ({
    type: AuthActions.AUTH_REFRESH_COMPLETED,
  }),
};

export const checkUserAuth = (): AuthActionTypes => ({
  type: AuthActions.AUTH_CHECK_START,
});

export const checkUserAuthActions = {
  authorized: (user: IUser): AuthActionTypes => ({
    type: AuthActions.AUTH_CHECK_AUTHORIZED,
    payload: { user },
  }),
  notAuthorized: (errorMessage?: string): AuthActionTypes => ({
    type: AuthActions.AUTH_CHECK_NOT_AUTHORIZED,
    payload: { errorMessage },
  }),
};

export const userLogout = (isBySystem?: boolean): AuthActionTypes => ({
  type: AuthActions.AUTH_LOGOUT_WATCHER,
  payload: { isBySystem },
});

export const userLogin = (user: IUser): AuthActionTypes => ({
  type: AuthActions.AUTH_LOGIN,
  payload: { user },
});

export const authLogoutActions = {
  logout: (isBySystem?: boolean): AuthActionTypes => ({
    type: AuthActions.AUTH_LOGOUT,
    payload: { isBySystem },
  }),
};
